const _jsxFileName = '';
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i];
    const fn = ops[i + 1];
    i += 2;
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}
import React from 'react';
import { Facebook, Instagram } from 'lucide-react';

const Footer = ({ settings, onNavigate, user }) => {
  // Default fallback if settings aren't fully loaded yet
  const email =
    _optionalChain([settings, 'optionalAccess', (_) => _.email]) || 'rsgleamofgolds@gmail.com';
  const address =
    _optionalChain([settings, 'optionalAccess', (_2) => _2.address]) || 'Luxury Lane, Makati City';

  const handleNav = (e, page) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onNavigate(page);
  };

  // Handler for links that should go to Order History for members, Transactions for admin, and Login for guests
  const handleCustomerCareLink = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (_optionalChain([user, 'optionalAccess', (_3) => _3.role]) === 'admin') {
      onNavigate('admin-transactions');
    } else if (user) {
      onNavigate('orders');
    } else {
      // Redirect guests to login/register page
      onNavigate('auth');
    }
  };

  // Handler specifically for Returns & Verification to go to Refunds tab
  const handleReturnsLink = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (_optionalChain([user, 'optionalAccess', (_4) => _4.role]) === 'admin') {
      onNavigate('admin-transactions');
    } else if (user) {
      onNavigate('refunds');
    } else {
      onNavigate('auth');
    }
  };

  return React.createElement(
    'footer',
    {
      className: 'bg-stone-100 text-stone-600 pt-20 pb-10 border-t border-stone-200',
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 52 },
    },
    React.createElement(
      'div',
      {
        className: 'max-w-7xl mx-auto px-6',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 53 },
      },
      React.createElement(
        'div',
        {
          className: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 54 },
        },

        /* Brand */
        React.createElement(
          'div',
          {
            className: 'space-y-6',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 57 },
          },
          React.createElement(
            'h4',
            {
              className: 'text-stone-900 font-serif text-xl tracking-wide cursor-pointer',
              onClick: (e) => handleNav(e, 'home'),
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 58 },
            },
            'Sparkling Gems'
          ),
          React.createElement(
            'p',
            {
              className: 'text-xs leading-6 font-light',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 59 },
            },
            'Curated luxury pieces in the Philippines. Authenticity-first listings, premium presentation, and a seamless member experience built for confident shopping.'
          ),
          React.createElement(
            'div',
            {
              className: 'flex gap-4',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 62 },
            },
            React.createElement(
              'a',
              {
                href: 'https://www.instagram.com/sparkling1gems',
                target: '_blank',
                rel: 'noopener noreferrer',
                className:
                  'w-8 h-8 rounded-full border border-stone-300 flex items-center justify-center hover:border-gold-600 hover:text-gold-600 transition-colors',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 63 },
              },
              React.createElement(Instagram, {
                size: 14,
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 64 },
              })
            ),
            React.createElement(
              'a',
              {
                href: 'https://www.facebook.com/sparkling1gems',
                target: '_blank',
                rel: 'noopener noreferrer',
                className:
                  'w-8 h-8 rounded-full border border-stone-300 flex items-center justify-center hover:border-gold-600 hover:text-gold-600 transition-colors',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 66 },
              },
              React.createElement(Facebook, {
                size: 14,
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 67 },
              })
            )
          ),
          /* Added dynamic contact preview */
          React.createElement(
            'div',
            {
              className: 'text-[10px] text-stone-400 mt-4',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 71 },
            },
            React.createElement(
              'p',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 72 } },
              address
            ),
            React.createElement(
              'p',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 73 } },
              email
            )
          )
        ),

        /* Customer Care */
        React.createElement(
          'div',
          { __self: this, __source: { fileName: _jsxFileName, lineNumber: 78 } },
          React.createElement(
            'h5',
            {
              className: 'text-stone-900 text-xs tracking-[0.2em] uppercase mb-6 font-bold',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 79 },
            },
            'Customer Care'
          ),
          React.createElement(
            'ul',
            {
              className: 'space-y-3 text-xs font-light',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 80 },
            },
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 81 } },
              React.createElement(
                'button',
                {
                  onClick: handleCustomerCareLink,
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 81 },
                },
                'Ordering & Payments'
              )
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 82 } },
              React.createElement(
                'button',
                {
                  onClick: handleCustomerCareLink,
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 82 },
                },
                'Shipping (Philippines)'
              )
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 83 } },
              React.createElement(
                'button',
                {
                  onClick: handleReturnsLink,
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 83 },
                },
                'Returns & Verification'
              )
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 84 } },
              React.createElement(
                'button',
                {
                  onClick: (e) => handleNav(e, 'contact'),
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 84 },
                },
                'Contact Support'
              )
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 85 } },
              React.createElement(
                'button',
                {
                  onClick: handleCustomerCareLink,
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 85 },
                },
                'Track Order'
              )
            )
          )
        ),

        /* Company */
        React.createElement(
          'div',
          { __self: this, __source: { fileName: _jsxFileName, lineNumber: 90 } },
          React.createElement(
            'h5',
            {
              className: 'text-stone-900 text-xs tracking-[0.2em] uppercase mb-6 font-bold',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 91 },
            },
            'The Maison'
          ),
          React.createElement(
            'ul',
            {
              className: 'space-y-3 text-xs font-light',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 92 },
            },
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 93 } },
              React.createElement(
                'button',
                {
                  onClick: (e) => handleNav(e, 'about'),
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 93 },
                },
                'About Sparkling Gems'
              )
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 94 } },
              React.createElement(
                'button',
                {
                  onClick: (e) => handleNav(e, 'services'),
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 94 },
                },
                'Our Services'
              )
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 95 } },
              React.createElement(
                'button',
                {
                  onClick: (e) => handleNav(e, 'about'),
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 95 },
                },
                'Sustainability'
              )
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 96 } },
              React.createElement(
                'button',
                {
                  onClick: (e) => handleNav(e, 'contact'),
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 96 },
                },
                'Careers'
              )
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 97 } },
              React.createElement(
                'button',
                {
                  onClick: (e) => handleNav(e, 'privacy-policy'),
                  className: 'hover:text-gold-600 transition-colors text-left',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 97 },
                },
                'Privacy Policy'
              )
            )
          )
        ),

        /* Newsletter */
        React.createElement(
          'div',
          { __self: this, __source: { fileName: _jsxFileName, lineNumber: 102 } },
          React.createElement(
            'h5',
            {
              className: 'text-stone-900 text-xs tracking-[0.2em] uppercase mb-6 font-bold',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 103 },
            },
            'Newsletter'
          ),
          React.createElement(
            'p',
            {
              className: 'text-xs font-light mb-4',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 104 },
            },
            'Subscribe to receive updates, access to exclusive deals, and more.'
          ),
          React.createElement(
            'div',
            {
              className: 'flex border-b border-stone-300 pb-2',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 105 },
            },
            React.createElement('input', {
              type: 'email',
              placeholder: 'Enter your email',
              className:
                'bg-transparent w-full text-sm outline-none text-stone-900 placeholder-stone-400',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 106 },
            }),
            React.createElement(
              'button',
              {
                className: 'text-gold-600 hover:text-gold-500 uppercase text-xs tracking-wider',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 111 },
              },
              'Join'
            )
          )
        )
      ),

      React.createElement(
        'div',
        {
          className:
            'border-t border-stone-200 pt-8 flex flex-col md:flex-row justify-between items-center text-[10px] text-stone-500',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 118 },
        },
        React.createElement(
          'p',
          {
            className: 'cursor-default select-none',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 119 },
          },
          '© 2026 Sparkling Gems, Philippines. All Rights Reserved.'
        ),
        React.createElement(
          'div',
          {
            className: 'flex gap-6 mt-4 md:mt-0',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 122 },
          },
          React.createElement(
            'span',
            { __self: this, __source: { fileName: _jsxFileName, lineNumber: 123 } },
            'Authentic Listings'
          ),
          React.createElement(
            'span',
            { __self: this, __source: { fileName: _jsxFileName, lineNumber: 124 } },
            '•'
          ),
          React.createElement(
            'span',
            { __self: this, __source: { fileName: _jsxFileName, lineNumber: 125 } },
            'Elegant Presentation'
          ),
          React.createElement(
            'span',
            { __self: this, __source: { fileName: _jsxFileName, lineNumber: 126 } },
            '•'
          ),
          React.createElement(
            'span',
            { __self: this, __source: { fileName: _jsxFileName, lineNumber: 127 } },
            'Member Wishlist'
          )
        )
      )
    )
  );
};

export default Footer;
